import { NotificationType } from "./commons/NotificationProvider";
import Svg from "../../Image/Svg";
import checkCircleOutline from "@iconify/icons-mdi/check-circle-outline";
import closeCircleOutline from "@iconify/icons-mdi/close-circle-outline";
import alertCircleOutline from "@iconify/icons-mdi/alert-circle-outline";
import infoCircleOutline from "@iconify/icons-mdi/info-circle-outline";
import useTheme from "../../../commons/hooks/use-theme";

export default function useNotificationIcon() {
  let theme = useTheme();

  const getNotificationIcon = (type: NotificationType) => {
    switch (type) {
      case "SUCCESS":
        return <Svg icon={checkCircleOutline} color={theme.successColor} size="medium" />;
      case "ERROR":
        return <Svg icon={closeCircleOutline} color={theme.material.error} size="medium" />;
      case "WARNING":
        return <Svg icon={alertCircleOutline} color={theme.material.secondary} size="medium" />;
      case "INFO":
        return <Svg icon={infoCircleOutline} color={theme.material.primary} size="medium" />;
      default:
        return undefined;
    }
  };

  return { getNotificationIcon };
}
